angular.module('app').component('manageSimulators', {
    template: '<iframe-wrapper src="\'RUF/simulator/manage?embed=true\'"></iframe-wrapper>'
});
